export default "__VITE_ASSET__dc9840a2__"